import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';
import { ObjectUtils } from 'src/core/utils/object';
import { CurrencyListDataService } from 'src/app/general/currencies/list/currency-list.data';
import { CurrencyExchangeListView } from './currency-exchanges.view';

@observer
export class CurrencyExchangeListController extends React.Component<ControllerProps<any>, any> {
	@observable
	defaultCurrency: CurrencySummary;

	@observable
	protected currencyDataService: CurrencyListDataService;

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected contextService: ContextService;

	@resolve
	protected formatService: FormatService;

	@resolve
	protected toast: ToastNotifications;

	constructor(props) {
		super(props);
	}

	@autobind
	private changeDefaultCurrency(newDefaultCurrency: CurrencySummary) {
		return this.dialogService.showYesNo('Change default currency?', 'No data will be lost, but currency exchange algorith will change.')
			.then(dialogResult => {
				if (dialogResult) {
					this.defaultCurrency.isDefault = false;
					this.defaultCurrency = newDefaultCurrency;
					this.defaultCurrency.isDefault = true;
				}
				return dialogResult;
			});
	}

	componentDidMount() {
		this.currencyDataService = CurrencyListDataService.make(this.contextService);
	}

	render() {
		if (this.currencyDataService == null) {
			return null;
		}

		return (
			<CurrencyExchangeListView
				title='Exhange rate'
				setBusy={this.props.setBusy}
				save={this.save}
				cancel={this.cancel}
				currencyQuery={this.currencyQuery}
				changeDefaultCurrency={this.changeDefaultCurrency}
				convert={this.convert}
				contextService={this.contextService}
				defaultCurrency={this.defaultCurrency}
			/>
		);
	}

	@autobind
	private currencyQuery() {
		this.currencyDataService.addSorting('id', 'asc', true);
		return this.currencyDataService.load(query => query)
			.then((res) => {
				this.defaultCurrency = res.find(e => e.isDefault);
				return res;
			});
	}

	@autobind
	private save() {
		return this.contextService.current()
			.then((context) => {
				this.props.setBusy(true);
				context.saveChanges()
					.then(() => {
						this.props.setBusy(false);
						this.toast.showDataSaved();
					})
					.catch((error) => {
						this.props.setBusy(false);
						this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
					});
			});
	}

	@autobind
	private cancel() {
		this.contextService.resetChanges();
	}

	@autobind
	private async convert(fromCurrencyId: number, toCurrencyId: number, amount: number, mode: number, bookingDate: Date, serviceDate: Date): Promise<number> {
		try {
			this.props.setBusy(true);
			const ctx = await this.contextService.current();
			const result = await ctx.ExchangeRate(fromCurrencyId, toCurrencyId, amount, bookingDate, serviceDate, mode).toArray();
			const item = result[result.length - 1];
			this.props.setBusy(false);
			return item == null ? null : item.amount;
		} catch (e) {
			this.props.setBusy(false);
			this.toast.showToast('Error!', ObjectUtils.parseError(e), 'error');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/products/currencies/exchanges/currency-exchanges.controller.tsx